import styled from 'styled-components';
import { FlexColumn } from '../Flex';

export const StatusContainer = styled(FlexColumn)`${({ theme }) => `
  white-space: nowrap;
  border-radius: ${theme.borderRadius[1]};
  padding: ${theme.padding[1]};
  padding-left: ${theme.padding[2]};
  padding-right: ${theme.padding[2]};
  background:${theme.colours.neutral[4]};
  color: ${theme.colours.neutral[10]};
  height:${theme.padding[4]};
  text-align:center;
  line-height:${theme.padding[4]};
`}`;

export const StatusContainerSuccess = styled(StatusContainer)`${({ theme }) => `
  background:${theme.colours.primary[1]};
  color: ${theme.colours.neutral[10]};
`}`;
